import { capitalized } from "../../../../../core/formatters"
import { evenlyItems } from "../../../helpers"
import { Chart } from "../../../models/charts/chart"
import type { ChartColor } from "../../../models/colors.values"
import { Series } from "../../../models/series"
import { excludedSeriesSet } from "../../../options/lightweight-charts/chart-type-options.map"
import { type GraphDataObject, type GraphDataObjectV1, type GraphDataObjectV2, type SeriesDOV1 } from "../../data-object/graph"
import { seriesFromDataObject } from "./series-do.transforms"
import type { AreaData, Time } from "lightweight-charts"

export const chartFromGraphDataObjectV1 = (chart: Chart, graph: GraphDataObjectV1): Chart => {
    copyCommonFields(chart, graph);
    const colors = evenlyItems(chart.seriesColors, graph.series.length)
    chart.series = graph.series
        .filter(onlyNoneExludedSeriesV1)
        .map((s, i) => mapDoToModel(s, i, colors))
        .sort(seriesSortFn)
    return chart;
}

const mapDoToModel = (s: SeriesDOV1, i: number, colors: ChartColor[]) =>
    seriesFromDataObject(s, typeof colors[i] === 'object' ? { ...colors[i] } : {})

const seriesSortFn = (a: Series, b: Series) => {
    const maxA = a.points.reduce((max, point) => Math.max(max, point.value), 0);
    const maxB = b.points.reduce((max, point) => Math.max(max, point.value), 0);
    return maxB - maxA;
}
const onlyNoneExludedSeriesV1 = (s: SeriesDOV1): boolean => {
    const excludedSeries = Array.from(excludedSeriesSet);
    const excluded: boolean = excludedSeries.some(substr => s.name.includes(substr));
    if (excluded) { console.info(`filtered series ${s.name}`); }
    return !excluded;
}

const copyCommonFields = (chart: Chart, graph: GraphDataObject): Chart => {
    chart.description = graph.description;
    chart.source = graph.source;
    return chart;
}

export const chartFromGraphDataObjectV2 = (chart: Chart, graph: GraphDataObjectV2): Chart => {
    copyCommonFields(chart, graph);
    // TODO: handles customs colors
    const colors = evenlyItems(chart.seriesColors, graph.series.length);
    const seriesObjs = graph.series.map((seriesName: string) => {
        return {
            name: seriesName,
            points: new Array<AreaData<Time>>()
        }
    });

    Object.entries(graph.data).forEach(([time, values], index: number) => {
        if (values[index]) {
            seriesObjs[index].points.push({ time: time.split('T')[0], value: values[index][0] });
        }
    });

    chart.series = seriesObjs.map(s => {
        return new Series(capitalized(s.name), s.points, {});
    })
    return chart;
}
